import { Anchor, AnchorProps } from '@mantine/core';

import { createMarkdownElementRenderer } from '../MarkdownComponentsWithHighlights';

export const MarkdownAnchorRenderer = createMarkdownElementRenderer(Anchor) as (
  props: React.ComponentProps<'a'> & AnchorProps,
) => JSX.Element;
